import { useState, useMemo } from "react";
import { Collapse } from "antd";

const faqItemsEn = [
    {
      key: '1',
      label: 'How recent are these leads?',
      children: (
        <p>Our leads are 100% verified and specifically targeted for commercial cleaning businesses. Each lead includes decision-maker contact information, company size, and industry specifics to help you close more deals.</p>
      ),
    },
    {
      key: '2',
      label: 'How were these leads collected or verified?',
      children: (
        <p>All leads are created through our proprietary research process and verified within 30 days of delivery. We use multiple verification methods including phone verification and email validation.</p>
      ),
    },
    {
      key: '3',
      label: 'Are these leads exclusive to me?',
      children: (
        <p>Yes! You can specify your target geographic area by zip code, city, state, or metro area. We customize each list to match your service territory and business goals.</p>
      ),
    },
    {
      key: '4',
      label: 'Can I use the leads more than once?',
      children: (
        <p>Absolutely. You can filter leads by industry sector (medical, industrial, office buildings, retail, etc.) and by specific services needed (daily cleaning, deep cleaning, carpet cleaning, etc.).</p>
      ),
    },
    {
      key: '5',
      label: 'What information comes with each lead?',
      children: (
        <p>Each lead includes business name, contact person, title, phone number, email address, physical address, company size, industry type, and specific cleaning needs when available.</p>
      ),
    },
    {
      key: '6',
      label: 'What if I want a list of just one industry, like all the restaurants in my city?',
      children: (
        <p>The industry you want is included in this list, along with other business types in the area around your chosen ZIP code. If you need a specific industry, or a larger geography, we're not able to provide it here. We recommend visiting our sister company, <a target="_blank" href='https://www.goleads.com'>https://www.goleads.com</a> and getting a list there.</p>
      ),
    },
    {
      key: '7',
      label: 'What’s the best way to contact these leads?',
      children: (
        <p>We recommend a multi-channel approach: start with a personalized email introduction, follow up with phone calls, and consider direct mail for high-value prospects. Our marketing kit includes templates for all channels.</p>
      ),
    },
    {
      key: '8',
      label: "Can I choose the area I want leads from?",
      children: (
        <p>Yes, you can filter by company size based on number of employees, square footage, or annual revenue. This helps you target businesses that match your service capacity and pricing structure.</p>
      ),
    },
    {
      key: '9',
      label: 'What kind of results should I expect?',
      children: (
        <p>Most of our Leads Now Commercial Cleaning clients see a massive return on this small investment. With 500 leads and our marketing plan template, you can expect at least 10 qualified prospects and 3 new clients in 90 days. With a once a week cleaning contracts at around $2000/mo, these leads don't cost, they pay!</p>
      ),
    },
    {
      key: '10',
      label: 'What kind of businesses are on the list?',
      children: (
        <p>Our lists include office buildings, medical facilities, retail stores, restaurants, manufacturing plants, warehouses, schools, churches, and other commercial properties that regularly need cleaning services.</p>
      ),
    },
    {
      key: '11',
      label: 'What happens if the contacts are wrong?',
      children: (
        <p>We guarantee 95% accuracy on all contact information. What happens if you bump into a bad contact? Leads Now Commercial Cleaning has you covered! When you download your file you will find and EXTRA 50 leads for a total of 550. We make it easy to get started!</p>
      ),
    },
    {
      key: '12',
      label: 'What if my zip code is small and it would not be 500 leads can I send 5 zip codes?',
      children: (
        <p>Good question. The way the list is pulled is we start in your listed ZIP and the radius is extended until we have 500. Actually, it's extended until we have 550 leads. No matter how many leads are in the actual zip code you enter, we'll add zip codes until we have enough for you.</p>
      ),
    }
  ];

const faqItemsEs = [
  { key: '1', label: '¿Qué tan recientes son estos leads?', children: (<p>Nuestros leads están 100% verificados y dirigidos específicamente a negocios de limpieza comercial. Cada lead incluye información de contacto del responsable de decisiones, tamaño de la empresa y datos del sector para ayudarte a cerrar más tratos.</p>) },
  { key: '2', label: '¿Cómo se recopilaron o verificaron estos leads?', children: (<p>Todos los leads se crean mediante nuestro proceso de investigación propio y se verifican en un plazo de 30 días desde la entrega. Usamos varios métodos de verificación, incluida verificación telefónica y validación de correo.</p>) },
  { key: '3', label: '¿Estos leads son exclusivos para mí?', children: (<p>¡Sí! Puedes especificar tu área geográfica objetivo por código postal, ciudad, estado o área metropolitana. Personalizamos cada lista según tu territorio de servicio y objetivos de negocio.</p>) },
  { key: '4', label: '¿Puedo usar los leads más de una vez?', children: (<p>Absolutamente. Puedes filtrar leads por sector (médico, industrial, oficinas, retail, etc.) y por servicios específicos necesarios (limpieza diaria, limpieza profunda, limpieza de alfombras, etc.).</p>) },
  { key: '5', label: '¿Qué información incluye cada lead?', children: (<p>Cada lead incluye nombre del negocio, persona de contacto, cargo, teléfono, correo, dirección física, tamaño de la empresa, tipo de industria y necesidades de limpieza específicas cuando estén disponibles.</p>) },
  { key: '6', label: '¿Y si quiero una lista de una sola industria, como todos los restaurantes de mi ciudad?', children: (<p>La industria que buscas está incluida en esta lista junto con otros tipos de negocio en la zona de tu código postal. Si necesitas una industria específica o una geografía más amplia, no podemos ofrecerla aquí. Recomendamos visitar nuestra empresa hermana <a target="_blank" rel="noopener noreferrer" href="https://www.goleads.com">https://www.goleads.com</a> para obtener una lista allí.</p>) },
  { key: '7', label: '¿Cuál es la mejor forma de contactar estos leads?', children: (<p>Recomendamos un enfoque multicanal: empieza con un correo de presentación personalizado, da seguimiento por teléfono y considera correo directo para prospectos de alto valor. Nuestro kit de marketing incluye plantillas para todos los canales.</p>) },
  { key: '8', label: '¿Puedo elegir el área de la que quiero leads?', children: (<p>Sí, puedes filtrar por tamaño de empresa (número de empleados, metros cuadrados o ingresos anuales). Esto te ayuda a dirigirte a negocios que encajen con tu capacidad de servicio y estructura de precios.</p>) },
  { key: '9', label: '¿Qué tipo de resultados puedo esperar?', children: (<p>La mayoría de nuestros clientes de Leads Now Commercial Cleaning obtienen un gran retorno de esta pequeña inversión. Con 500 leads y nuestra plantilla de plan de marketing, puedes esperar al menos 10 prospectos calificados y 3 clientes nuevos en 90 días. Con contratos de limpieza semanal de unos $2000/mes, estos leads no cuestan, ¡pagan!</p>) },
  { key: '10', label: '¿Qué tipo de negocios hay en la lista?', children: (<p>Nuestras listas incluyen edificios de oficinas, instalaciones médicas, tiendas, restaurantes, plantas de manufactura, almacenes, escuelas, iglesias y otras propiedades comerciales que necesitan servicios de limpieza con regularidad.</p>) },
  { key: '11', label: '¿Qué pasa si los contactos son incorrectos?', children: (<p>Garantizamos un 95% de precisión en toda la información de contacto. ¿Qué pasa si encuentras un contacto malo? ¡Leads Now Commercial Cleaning te respalda! Al descargar tu archivo encontrarás 50 leads EXTRA por un total de 550. ¡Facilitamos el inicio!</p>) },
  { key: '12', label: '¿Si mi código postal es pequeño y no hay 500 leads, puedo enviar 5 códigos postales?', children: (<p>Buena pregunta. La lista se arma empezando por tu código postal y se amplía el radio hasta tener 500. De hecho, se amplía hasta tener 550 leads. No importa cuántos leads haya en el código que ingreses, añadiremos códigos hasta tener suficientes para ti.</p>) },
];

export default function FAQ({ lang = "en" }) {
  const [openKey, setOpenKey] = useState();
  const faqItems = lang === "es" ? faqItemsEs : faqItemsEn;

  const { leftItems, rightItems } = useMemo(() => {
    const mid = Math.ceil(faqItems.length / 2);
    return {
      leftItems: faqItems.slice(0, mid),
      rightItems: faqItems.slice(mid),
    };
  }, [faqItems]);

  const renderItem = (item) => (
    <div
      key={item.key}
      className="bg-[#E4F7F9] rounded-4xl shadow-sm border border-[#26A94A]/40 p-1"
    >
      <Collapse
        accordion
        ghost
        expandIconPosition="end"
        activeKey={openKey === item.key ? item.key : undefined}
        onChange={(key) => {
          // antd passes a string in accordion mode (or undefined when closing)
          setOpenKey(key || undefined);
        }}
        items={[
          {
            key: item.key,
            label: (
              <h4 className="text-[#1465B7] text-lg font-medium">
                {item.label}
              </h4>
            ),
            children: (
              <div className="text-gray-600 text-lg leading-relaxed">
                {item.children}
              </div>
            ),
          },
        ]}
        className="bg-[#E4F7F9] rounded-lg"
      />
    </div>
  );

  return (
    <div className="max-w-5xl mx-auto">
          <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-6">
           <h2 className="text-2xl text-[#1465B7] font-semibold">{lang === "es" ? "Preguntas frecuentes" : "FAQ"}</h2>
         </div>
         </div>
    <div className="grid grid-cols-1 md:grid-cols-2 auto-rows-min items-start mt-6">
      {/* Left column */}
      <div>
        {leftItems.map((item) => renderItem(item))}
      </div>

      {/* Right column */}
      <div>
        {rightItems.map((item) => renderItem(item))}
      </div>
    </div>
    </section>
    </div>
  );
}
